import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

export { default as Navigation } from "./components/Navigation.jsx";
export { default as Browse } from "./components/Browse.jsx";
export { default as MyPatterns } from "./components/MyPatterns.jsx";
export { default as Quiz } from "./components/Quiz.jsx";
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
